<template>
    <div class="input-wrap relative flex items-center w-full">
        <textarea
            :id="name"
            :value="value"
            :name="name"
            class="border border-gray-450 text-black-600 focus:outline-none focus:shadow-gold px-4 py-3 w-full disabled:bg-gray-300 disabled:text-gray-500"
            :class="{
                'border-red-500 text-red-500 focus:border-red-500 focus:text-red-500' : hasErrors,
                'focus:border-gold-500 focus:text-black-600': ! hasErrors
            }"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
        />
        <slot />
    </div>
</template>

<script>
export default {
  name: 'Textarea',
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasErrors: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
